import script from "./Accordian.vue?vue&type=script&setup=true&lang=js"
export * from "./Accordian.vue?vue&type=script&setup=true&lang=js"

import "./Accordian.vue?vue&type=style&index=0&id=454dc87e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454dc87e"]])

export default __exports__